import {Http, ResponseContentType} from "@angular/http";
import {Observable} from "rxjs";
import {AriadnextProfile, AriadnextUser} from "../entity";
import {Injectable} from "@angular/core";

@Injectable()
export class AriadnextService {

    constructor(private _http: Http) {
    }

    getResultByProfile(profileId: number): Observable<AriadnextProfile> {
        return this._http.get(`/api/backoffice/verification/ariadnext/${profileId}`)
            .map(response => response.json());
    }

    getResultByUser(profileId: number, userId: number): Observable<AriadnextUser> {
        return this._http.get(`/api/backoffice/verification/ariadnext/${profileId}/users/${userId}`)
            .map(response => response.json());
    }

    createApplicant(profileId: number, userId: number, byPhone: boolean): Observable<any> {
        return this._http.post(`/api/backoffice/verification/ariadnext/${profileId}`, {clientUserId: userId, sendLinkApproach: byPhone ? 'PHONE' : 'EMAIL'});
    }

    verify(profileId: number, userId: number): Observable<any> {
        return this._http.patch(`/api/backoffice/verification/ariadnext/${profileId}`, {
            userId: userId,
            status: 'verify'
        });
    }

    decline(profileId: number, userId: number): Observable<any> {
        return this._http.patch(`/api/backoffice/verification/ariadnext/${profileId}`, {
            userId: userId,
            status: 'decline'
        });
    }

    downloadDocument(fileUid: string) {
        return this._http.get(`/api/backoffice/verification/ariadnext/documents/${fileUid}`, {responseType: ResponseContentType.Blob});
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/ariadnext.service.ts